import script from "./InfoTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoTable.vue?vue&type=script&setup=true&lang=ts"

import "./InfoTable.vue?vue&type=style&index=0&id=51e7f5fd&lang=css"

const __exports__ = script;

export default __exports__